import { render, staticRenderFns } from "./SocialPostComment.vue?vue&type=template&id=002f9fb2&"
import script from "./SocialPostComment.vue?vue&type=script&lang=js&"
export * from "./SocialPostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports